import { render } from "./full-bleed.vue?vue&type=template&id=4b9caa30"
import script from "./full-bleed.vue?vue&type=script&setup=true&lang=js"
export * from "./full-bleed.vue?vue&type=script&setup=true&lang=js"

import "./full-bleed.vue?vue&type=style&index=0&id=4b9caa30&lang=scss"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.17_webpack@5.97.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"packages/client/src/core-components/layouts/full-bleed.vue"]])

export default __exports__